if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}

// Perf 30Sep: zoom photos no longer load with the page. Once the page has loaded, fetch the zoom
// photo for the photo on screen only, then for each photo swiped to or touched.
(function () {
  function warmZoom(mediaId) {
    if (!mediaId) return;
    document
      .querySelectorAll('.product-media-modal__content img[loading="lazy"][data-media-id="' + mediaId + '"]')
      .forEach(function (img) {
        img.loading = 'eager';
      });
  }

  function galleryMediaId(item) {
    return item && item.dataset.mediaId ? item.dataset.mediaId.split('-').pop() : null;
  }

  function start() {
    document.querySelectorAll('media-gallery [id^="GalleryViewer"]').forEach(function (viewer) {
      warmZoom(galleryMediaId(viewer.querySelector('.product__media-item.is-active') || viewer.querySelector('.product__media-item')));
      viewer.addEventListener('slideChanged', function (event) {
        warmZoom(galleryMediaId(event.detail.currentElement));
      });
    });
  }

  document.addEventListener('pointerdown', function (event) {
    var toggle = event.target.closest && event.target.closest('.product__media-toggle');
    if (toggle) warmZoom(toggle.dataset.mediaId);
  });

  function afterLoad() {
    if (window.requestIdleCallback) window.requestIdleCallback(start, { timeout: 3000 });
    else setTimeout(start, 200);
  }
  if (document.readyState === 'complete') afterLoad();
  else window.addEventListener('load', afterLoad);
})();
